import { useTranslation } from "react-i18next";
import { ScanFace } from "lucide-react";
import { LangToggle, ThemeToggle } from "../../components/controls/Toggles";
import { NeuCard } from "../../components/neu/Neu";

// Shared centered shell for the public auth pages (forgot password, set password).
export const AuthShell = ({ title, subtitle, children, testId }) => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-background px-5 py-10 pt-[max(2.5rem,calc(env(safe-area-inset-top)+1rem))] pb-[max(2.5rem,calc(env(safe-area-inset-bottom)+1rem))]">
      <div className="w-full max-w-md">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="neu flex h-12 w-12 items-center justify-center rounded-2xl p-0">
              <ScanFace className="h-6 w-6 text-primary" />
            </div>
            <p className="text-xl font-black">{t("app.name")}</p>
          </div>
          <div className="flex gap-2">
            <LangToggle />
            <ThemeToggle />
          </div>
        </div>
        <NeuCard className="animate-rise-in p-8" data-testid={testId}>
          <h1 className="text-2xl font-black tracking-tight">{title}</h1>
          {subtitle ? <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p> : null}
          {children}
        </NeuCard>
      </div>
    </div>
  );
};
